const DragScroller = {
  isScrolling: false,
  startX: 0,
  startY: 0,
  scrollLeft: 0,
  scrollTop: 0,

  /**
   * Sets up the object for scrolling, given a mouse event.
   *
   * @param {Object} event - A mouse event.
   * @param {Number} event.pageX - The x-coordinate of the mouse.
   * @param {Number} event.pageY - The y-coordinate of the mouse.
   * @param {HTMLElement} event.target - The element that the mouse is currently over.
   * @returns {void}
   */
  StartScroll(event) {
    this.isScrolling = true;
    this.startX = event.pageX - event.target.offsetLeft;
    this.startY = event.pageY - event.target.offsetTop;
    this.scrollLeft = event.target.scrollLeft;
    this.scrollTop = event.target.scrollTop;
  },

  /**
   * Scrolls the target element based on mouse movement.
   *
   * @param {Object} event - A mouse event.
   * @param {Number} event.pageX - The current x-coordinate of the mouse.
   * @param {Number} event.pageY - The current y-coordinate of the mouse.
   * @param {HTMLElement} event.target - The element that is being scrolled.
   * 
   * This function adjusts the scroll position of the target element
   * according to the distance the mouse has moved since scrolling started.
   * Scrolling is only performed if the isScrolling flag is true.
   * @returns {void}
   */
  ScrollNow(event) {
    if (!this.isScrolling) return;
    const x = event.pageX - event.target.offsetLeft;
    const y = event.pageY - event.target.offsetTop;
    const walkX = (x - this.startX) * 2; // Adjust the scroll speed
    const walkY = (y - this.startY) * 2; // Adjust the scroll speed
    event.target.scrollLeft = this.scrollLeft - walkX;
    event.target.scrollTop = this.scrollTop - walkY;
  },

  /**
   * Resets the isScrolling flag to false.
   * This is used to terminate the scrolling behavior when the user releases the mouse button.
   * @returns {void}
   */
  StopScroll() {
    this.isScrolling = false;
  }
};

export default DragScroller;